import styled from '@emotion/styled';
import { Button, FieldRoot } from '@lbcamden/lib-react';

export const RecommendationListRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(5)};
`;

export const RecommendationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};

  ${FieldRoot} {
    gap: ${({ theme }) => theme.spacing(1)} !important;
  }

  > ${Button} {
    align-self: flex-end;
  }
`;

export const Divider = styled.div`
  min-width: 100%;
  border-bottom: ${({ theme }) => theme.borderLight};
`;
